export enum SiteVertical {
  TRAVEL = 'travel',
}
